export default "__VITE_ASSET__CjYArfNF__"